import { ITemplate } from "models/ITemplate";

export interface IEditTemplateDialogProps {
  template?: ITemplate | null;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export const FIELD_LIMITS = {
  NAME_MAX_LENGTH: 150,
  NAME_WARNING_THRESHOLD: 120,
  DESCRIPTION_MAX_LENGTH: 2000,
  DESCRIPTION_WARNING_THRESHOLD: 1800,
} as const;

export const DIALOG_LABELS = {
  CREATE: "Add Template",
  EDIT: "Update Template",
} as const;

export const FIELD_LABELS = {
  ICON: "Icon",
  TITLE: "Title",
  DESCRIPTION: "Description",
  PROMPT: "Prompt",
  RECOMMENDED_LLM: "Recommended LLM",
  KNOWLEDGE_COMPONENTS: "Pre-selected Knowledge Components",
  ACTIVE: "Active",
  SHOW_ON_CHAT_SCREEN: "Show on Chat Screen",
  ACCESS_CONTROL: "Access Control",
  SELECTED_USERS: "Selected Users",
} as const;
